<template>
    <div 
        class="module module-gallery" 
    >
            <OwlCarousel v-if="data" :options="options" role="list">
                <li   v-for="(project, i) in data" :key="i" >
                    <router-link 
                        :to="project.link ? project.link.replace(homeUrl, '') : '' "
                        ref="link">  
                        <WpImage  
                            :data="project.featured_image_src || getPlaceholder('projects')" 
                            size="large" 
                            background
                            caption
                            class="wide-image"
                            placeholder
                            lazy  />
                        <div class="slider-info">
                            <h3 class="item-title" v-html="project.title.rendered"></h3>
                            <p class="intro" v-html="project.acf.facts.intro"></p>
                            <div class="project-info">
                                <div class="project-facts">
                                    <div class="facts-item">
                                        <p class="label" v-html="'Tidspunkt'"></p>
                                        <p v-html="project.acf.facts.year"></p>
                                    </div>
                                    <div class="facts-item">
                                        <p class="label" v-html="'Sted'"></p>
                                        <p v-html="project.acf.facts.place"></p>
                                    </div>
                                    <div class="facts-item">
                                        <Categories
                                                v-if="project.acf && project.acf._category" 
                                                :categories="project.acf._category" :taxonomy="'projects_cat'" :link="false"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </router-link>
                </li>
            </OwlCarousel>
    </div>
</template>

<script>
import WpImage from '@/components/elements/WpImage'
import OwlCarousel from '@/components/elements/OwlCarousel'
import Categories from '@/components/blocks/CategoriesBlock';

import { mapGetters } from 'vuex'

export default {
    name: 'project-gallery',
    props: ['data'],
    data() {
        return {
            homeUrl: window.WPVUE.home_url,
        }
    },
    computed:{

        options() {
            const VM = this;
            return {
                items: 1,
                margin: 0,
                loop: false,
                center: false,
                nav: true,
                autoplay: false,
                mouseDrag: true,
                touchDrag: true,
                pullDrag: true,
                freeDrag: false,
                callbacks: true,
                navText: [VM.svgIcons.prevArrow, VM.svgIcons.nextArrow],
            }
        },
        ...mapGetters([
            'getPlaceholder'
        ]),
    },

    components:{
        WpImage,
        OwlCarousel,
        Categories
    },
    mounted(){
    },
    
};
</script>


